import View from './view';
import {useSelector} from 'react-redux';
import {useAppDispatch} from '../../../redux';
import {profileNotificationsByIdSelector} from '../../../redux/selectors/profile';
import {Props} from './model';
import {useEffect} from 'react';
import {NotificationStatus} from '../../../shared/models/profile/notification';
import {readNotification} from '../../../redux/actions/profile';
import {getProfileNotification} from '../../../redux/actions/profile';

export const NotificationDesktop = (props: Props) => {
  const id = props.id;
  const notification = useSelector(profileNotificationsByIdSelector(id));
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getProfileNotification(id));
  }, [id]);

  useEffect(() => {
    if (notification?.id && notification.statusId === NotificationStatus.NotRead) {
      dispatch(readNotification(notification?.id || 0));
    }
  }, [notification?.id]);

  const newProps = {
    notification,
    onModalClose: props.onModalClose,
    onNotificationPress: props.onNotificationPress,
    navigation: props.navigation,
  };

  return View(newProps);
};
